module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "alt_text",
      "aria-hidden": "true",
      "border": "0",
      "height": "100",
      "src": _vm.imgUrl,
      "width": "100"
    },
    on: {
      "error": _vm.useDefaultImage
    }
  }), _vm._v(" "), _c('h1', {
    style: ({
      'color': _vm.primaryColor
    }),
    attrs: {
      "id": "title"
    }
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63b75acc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/assets/pages/Logo/Logo.vue
// module id = 972
// module chunks = 3